// extracted by mini-css-extract-plugin
export default {"wrapper":"BlackFriday_wrapper","light":"BlackFriday_light","background":"BlackFriday_background"};